import "./amplify-config";
import * as React from 'react';
import * as ReactDOM from 'react-dom';

// import Analytics from '@aws-amplify/analytics';
import './scss/index.scss';
import './styles.css'
// console.log("INDEX LOG");
import * as serviceWorker from './serviceWorker';
import RootApp from './RootApp';
/* Amplify.configure({
    ...aws_exports,
    Auth: {
        // REQUIRED - Amazon Cognito Identity Pool ID,
        identityPoolId: 'us-east-2:5c2aa77e-9c72-46f7-bb9e-52197b858b78',
        // REQUIRED - Amazon Cognito Region
        region: 'us-east-2',
        // OPTIONAL - Amazon Cognito User Pool ID
        userPoolId: 'us-east-2_JDUX7dvIV',
        // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
        userPoolWebClientId: '33rg8mpfoa9po1jo9evdavt2ld',
        // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
        mandatorySignIn: true,
        // authenticationFlowType: 'AMAZON_COGNITO_USER_POOLS'
    },
    graphql_headers: async () => {
        const currentSession = await Auth.currentSession();
        return { Authorization: currentSession.getIdToken().getJwtToken() };
    }
}); */

ReactDOM.render(<RootApp />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
